import { render } from "./ComboScoreComponent.vue?vue&type=template&id=7bb332c4"
import script from "./ComboScoreComponent.vue?vue&type=script&lang=js"
export * from "./ComboScoreComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__